import { render, staticRenderFns } from "./GenerateFee.vue?vue&type=template&id=1f8643f8"
import script from "./GenerateFee.vue?vue&type=script&lang=js"
export * from "./GenerateFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports